import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ApplicationState } from 'store';
import { AcademyState, AcademyLive } from 'store/modules/academy_store/types';
import Loader from 'components/atoms/loader';
import AcademyPlayer from 'components/atoms/academy_player';
import { Container } from './styles';

interface AcademyContentDetailProps {
  id: number;
  source: 'conteudos' | 'meus-treinamentos';
}

const AcademyContentDetail: React.FC<AcademyContentDetailProps> = ({ id, source }) => {
  const history = useHistory();
  const { contents, mySubscriptions, request } = useSelector<ApplicationState, AcademyState>(
    (s) => s.session.academy,
  );

  const isTraining = source === 'meus-treinamentos';
  const backTo = isTraining ? '/academy/meus-treinamentos' : '/academy/conteudos';
  const backLabel = isTraining ? 'Voltar para lista de Treinamentos' : 'Voltar para Conteúdos';
  const loading = isTraining ? request.mySubscriptions.loading : request.contents.loading;

  const trainingLives = mySubscriptions
    .map((sub) => sub.live)
    .filter((live): live is AcademyLive => Boolean(live));
  const pool = isTraining ? trainingLives : contents;
  const live = pool.find((item) => item.id === id) || contents.find((item) => item.id === id);

  const backButton = (
    <button type="button" className="back-link" onClick={() => history.push(backTo)}>
      <i className="material-icons">chevron_left</i>
      {backLabel}
    </button>
  );

  if (!live && loading) {
    return (
      <Container>
        {backButton}
        <div className="loading-wrapper">
          <Loader />
        </div>
      </Container>
    );
  }

  if (!live) {
    return (
      <Container>
        {backButton}
        <div className="empty-state">
          <p>Conteúdo não encontrado.</p>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      {backButton}
      <div className="detail-card">
        {live.recording_embed_url && (
          <AcademyPlayer src={live.recording_embed_url} title={live.title} />
        )}
        <div className="badges">
          {live.content_type && <span className="badge-pill">{live.content_type}</span>}
          {live.category && <span className="badge-pill">{live.category}</span>}
        </div>
        <div className="detail-title">{live.title}</div>
        {live.description && <div className="detail-description">{live.description}</div>}
      </div>
    </Container>
  );
};

export default AcademyContentDetail;
